import { getBrand } from "@faire/help-center-utils/serialized-data/getBrand";
import { getRetailer } from "@faire/help-center-utils/serialized-data/getRetailer";
export var getRetailerOrBrandCountry = function getRetailerOrBrandCountry() {
  var _getRetailer, _getBrand, _ref;
  var retailerCountry = (_getRetailer = getRetailer()) === null || _getRetailer === void 0 ? void 0 : _getRetailer.country;
  var brandCountry = (_getBrand = getBrand()) === null || _getBrand === void 0 ? void 0 : _getBrand.based_in;
  return (_ref = retailerCountry !== null && retailerCountry !== void 0 ? retailerCountry : brandCountry) !== null && _ref !== void 0 ? _ref : "";
};